export default __webpack_public_path__ + "static/media/travelApp.94cfa3a7.png";